<template>
	<div>
		<div
			class="quescard d-flex relativeclass"
			:id="'ques' + data.questionKey + selectedSection.sectionID"
		>
			<div
				:style="
					data.questionBody.options.length == 2 &&
					data.questionBody.questionMedia === null
						? 'height:90%'
						: ''
				"
				class="quescard-colorbar ml-2"
				:class="
					data.answerStatus.later
						? 'side-blocks-later'
						: data.answerStatus.attempted
						? 'side-blocks-attempted'
						: data.questionBody.config.config.required
						? 'side-blocks-active'
						: 'side-blocks-unattempted'
				"
			></div>
			<div class="d-flex flex-column mcqcard">
				<b-row class="mb-2">
					<b-col>
						<div class="d-flex align-items-center">
							<div class="quescard-mainhead">MCQ's</div>
							<div
								class="marktagbox marginmcq"
								v-if="testDetails.config.dispMarks"
							>
								{{ data.questionBody.marks }} Marks
							</div>
						</div>
					</b-col>

					<b-col class="d-flex justify-content-end">
						<template v-if="testDetails.config.dispReqStatus">
							<div
								class="reqd-txt mr-3"
								v-if="data.questionBody.config.config.required"
							>
								<img
									src="../../assets/newimgs/testscreen/reqQuesIcon.svg"
									alt=""
									class=""
								/>
								Required
							</div>
						</template>
						<div
							class="
              markforlatercheckbox 
              dodontcheckbox
                d-flex
                align-items-center
                justify-content-end
              "
						>
							<b-form-checkbox
								name="checkbox-1"
								v-model="data.answerStatus.later"
								@change="markforLater()"
							>
								Mark for later
							</b-form-checkbox>
						</div>
					</b-col>
				</b-row>

				<div class="d-flex flex-column">
					<div v-if="data.questionBody.questionMedia != null" class="mt-2">
						<div
							@mouseover="showmainimgviewicon = true"
							@mouseleave="showmainimgviewicon = false"
							class="question-image-container mb-2 d-flex align-items-center justify-content-center position-relative"
							v-if="isImage(data.questionBody.questionMediaType)"
						>
							<img
								class="object-fit-contain w-100 h-100"
								:src="data.questionBody.questionMedia"
								alt=""
							/>
							<div class="image-blur-overlay" v-if="showmainimgviewicon"></div>
							<span
								v-if="showmainimgviewicon"
								style="top: 108px;left: 71px;"
								class="position-absolute view-image-icon pointer"
								@click.stop.prevent="
									openPreviewMainimage(data.questionBody.questionMedia)
								"
							>
								<img
									src="../../assets/newui-img/test-screen/imagepreview.svg"
									alt=""
									class="mr-1"
								/>
								View Image
							</span>
						</div>
						<div
							v-if="isAudio(data.questionBody.questionMediaType)"
							class="d-flex align-items-center mb-2"
						>
							<Media
								:kind="'audio'"
								:isMuted="false"
								:src="data.questionBody.questionMedia"
								:autoplay="false"
								:controls="true"
								:loop="true"
								class="mcqdatacard-audio"
							></Media>
						</div>
						<div
							v-if="isVideo(data.questionBody.questionMediaType)"
							class="d-flex align-items-center mb-2"
						>
							<Media
								:kind="'video'"
								:isMuted="false"
								:src="data.questionBody.questionMedia"
								:autoplay="false"
								:controls="true"
								:loop="true"
								class="qb-image-preview"
							></Media>
						</div>
					</div>

					<div class="sec-ques-style d-flex mb-3 mt-2">
						<div>Q{{ showindex }}.</div>
						<div
							class="ml-1 sec-ques-style topicDescBreak"
							v-html-safe="data.questionBody.question"
						></div>
					</div>

					<div v-if="data.questionBody.noOfCorrectOptionsAllowed > 1">
						<b-form-checkbox-group
							@change="selectedOption()"
							v-model="data.answer"
							class="ml-3 pb-2 newblueradios mob-radio-group mob-chkbx-group"
							size="sm"
							:class="
								selectedCount == data.questionBody.noOfCorrectOptionsAllowed &&
								!data.answer.includes(option.value)
									? 'disablecursor'
									: ''
							"
						>
							<b-row>
								<b-col
									v-for="(option, index) in data.questionBody.options"
									:key="index"
									:cols="checkColumnText() ? '6' : '3'"
									class="mb-4"
								>
									<b-form-checkbox
										:value="
											isValueExist(option) ? option.value : option.mediaValue
										"
										:disabled="
											selectedCount ==
												data.questionBody.noOfCorrectOptionsAllowed &&
												!data.answer.includes(option.value || option.mediaValue)
										"
									>
										<span v-if="isValueExist(option)">{{ option.value }}</span>
										<span
											v-if="option.media"
											class="option-media-image d-flex position-relative"
											@mouseover="showviewicon = index"
											@mouseleave="showviewicon = null"
										>
											<img
												:src="option.media"
												alt=""
												class="w-100 h-100 overflow-hidden br-5px"
											/>
											<div
												v-if="showviewicon === index"
												class="image-blur-overlay"
											></div>
											<span
												class="position-absolute view-image-icon"
												v-if="showviewicon === index"
												@click.stop.prevent="openPreview(option.media)"
											>
												<img
													src="../../assets/newui-img/test-screen/imagepreview.svg"
													alt=""
													class="mr-1"
												/>
												View
											</span>
										</span>
									</b-form-checkbox>
								</b-col>
							</b-row>
						</b-form-checkbox-group>
					</div>
					<div class="ml-3 pb-2 newblueradios mob-radio-group" v-else>
						<b-form-group>
							<b-form-radio-group
								v-model="data.answer"
								@change="selectedOption()"
								class="checkbox-btns"
							>
								<b-row>
									<b-col
										v-for="(option, index) in data.questionBody.options"
										:key="index"
										:cols="checkColumnText() ? '6' : '3'"
										class="mb-4"
									>
										<b-form-radio
											:value="option.value ? option.value : option.mediaValue"
										>
											<span v-if="option.value">{{ option.value }}</span>
											<span
												v-if="option.media"
												class="option-media-image d-flex position-relative"
												@mouseover="showviewicon = index"
												@mouseleave="showviewicon = null"
											>
												<img
													:src="option.media"
													alt=""
													class="w-100 h-100 overflow-hidden br-5px"
												/>
												<div
													v-if="showviewicon === index"
													class="image-blur-overlay"
												></div>
												<span
													class="position-absolute view-image-icon"
													v-if="showviewicon === index"
													@click.stop.prevent="openPreview(option.media)"
												>
													<img
														src="../../assets/newui-img/test-screen/imagepreview.svg"
														alt=""
														class="mr-1"
													/>
													View
												</span>
											</span>
										</b-form-radio>
									</b-col>
								</b-row>
							</b-form-radio-group>
						</b-form-group>
					</div>
				</div>
			</div>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="isImageModalOpen"
			:lazy="true"
			:static="true"
		>
			<div class="">
				<img
					:src="previewImage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewImage"
				/>
			</div>
		</b-modal>
		<div
			v-if="isImageModalOpen"
			@click="isImageModalOpen = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt=""
			/>
		</div>
		<b-modal
			id="viewimagemodal"
			centered
			hide-footer
			hide-header
			v-model="openPreviewMainimagemodal"
			:lazy="true"
			:static="true"
		>
			<div class="">
				<img
					:src="previewMainimage"
					alt="Preview"
					class="h-100 w-100 overflow-hidden border-image"
					v-if="previewMainimage"
				/>
			</div>
		</b-modal>
		<div
			v-if="openPreviewMainimagemodal"
			@click="openPreviewMainimagemodal = false"
			class="mcq-image-modalclose pointer"
		>
			<img
				class="rotate-on-hover"
				src="../../assets/newui-img/test-screen/imagexclose.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
// import { defineComponent } from '@vue/com position-api'
import { isImage, isVideo, isAudio } from "../../checkFileType.js";
import Media from "@dongido/vue-viaudio";
import { mapGetters } from "vuex";

export default {
	name: "mcqAnswercard",
	components: {
		Media,
	},
	props: {
		data: Object,
		showindex: Number,
	},
	data() {
		return {
			markLater: false,
			rad_option: null,
			option: "MCQ",
			showviewicon: null,
			previewImage: null,
			isImageModalOpen: false,
			previewMainimage: null,
			showmainimgviewicon: false,
			openPreviewMainimagemodal: false,
		};
	},
	created() {
		if (!this.data.answer) {
			this.data.answer = [];
		}
	},
	computed: {
		...mapGetters("sectionVUEX", {
			testDetails: "getTestDetails",
		}),
		...mapGetters("testVUEX", {
			selectedSection: "getSelectedSection",
		}),
		...mapGetters("questionVUEX", {
			currentQuestionData: "getCurrentQuestionData",
		}),
		selectedCount() {
			return this.data.answer.length;
		},
	},
	watch: {
		selected() {
			if (this.selected) {
				this.selectedOption();
			}
		},
	},
	methods: {
		isValueExist(option) {
			return (
				option.value != "" && option.value != null && option.value != undefined
			);
		},
		checkColumnText() {
			return this.data.questionBody.options.some((opt) => opt.value);
		},
		openPreviewMainimage(imageUrl) {
			this.previewMainimage = imageUrl;
			this.openPreviewMainimagemodal = true;
		},
		openPreview(imageUrl) {
			this.previewImage = imageUrl;
			this.isImageModalOpen = true;
		},
		isImage,
		isVideo,
		isAudio,
		markforLater() {
			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				answer: this.data.answer,
				answerStatus: this.data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			console.log(payload);

			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
		normalizeAnswer(val) {
			if (!val) return val;
			if (typeof val === "string" && val.includes("-")) {
				return val.split("-")[0];
			}
			return val;
		},
		selectedOption() {
			const noAnswer =
				this.data.answer == null ||
				this.data.answer === "" ||
				(Array.isArray(this.data.answer) && this.data.answer.length === 0);

			if (noAnswer) {
				// No answer selected → mark as unattempted
				this.data.answerStatus.active = true;
				this.data.answerStatus.unattempted = true;
				this.data.answerStatus.attempted = false;
			} else {
				// At least one option selected → mark as attempted
				this.data.answerStatus.active = true;
				this.data.answerStatus.unattempted = false;
				this.data.answerStatus.attempted = true;
			}
			// const cleanAnswer = Array.isArray(this.data.answer)
			// 	? this.data.answer.map(this.normalizeAnswer)
			// 	: this.normalizeAnswer(this.data.answer);

			let payload = {
				topicID: this.testDetails.topicID,
				testID: this.testDetails.testID,
				groupID: this.testDetails.groupID,
				sectionID: this.selectedSection.sectionID,
				questionKey: this.data.questionKey,
				answer: this.data.answer,
				answerStatus: this.data.answerStatus,
				attemptNo: this.testDetails.attemptNo,
			};
			this.$store.dispatch("testVUEX/saveAnswer", payload);
			this.$store.commit("testVUEX/updateSectionDetails", payload);
		},
	},
};
</script>

<style>
@import "../../assets/globalcss/style.css";
.mob-radio-group .custom-control-inline {
	width: 100%;
	margin-right: 0px;
}

.mob-radio-group .custom-radio.b-custom-control-sm,
.input-group-sm .custom-radio {
	font-size: 0.875rem;
	line-height: 1.5;
	padding-left: 31px;
	padding-top: 11px;
}

.mob-radio-group .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3a3c40;
	max-width: 100%;
	min-width: fit-content;
	word-break: break-word;
	cursor: pointer;
}

.mob-radio-group .custom-control-label::before {
	border: 2px solid #20639b;
}

.mob-radio-group .custom-radio.b-custom-control-sm .custom-control-label::after,
.input-group-sm .custom-radio .custom-control-label::after {
	border: 1px solid #20639b;
	border-radius: 50%;
}

.mob-radio-group .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #20639b;
}

.mob-radio-group
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 2px solid #20639b;
	border-radius: 50%;
}
.mob-chkbx-group .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 0px !important;
	border-color: #20639b !important;
	background-color: #20639b;
}
.mob-chkbx-group
	.custom-checkbox
	.b-custom-control-sm
	.custom-control-label::after,
.mob-chkbx-group .input-group-sm .custom-checkbox .custom-control-label::after {
	top: 0.22rem;
	left: -1.268rem;
	width: 0.875rem;
	height: 0.875rem;
	background-size: 50% 50%;
}
.mob-chkbx-group .input:focus {
	border-color: #20639b !important;
}

.mob-chkbx-group .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #3a3c40;
	max-width: 100%;
	min-width: -webkit-fit-content;
	min-width: -moz-fit-content;
	min-width: fit-content;
	word-break: break-word;
	cursor: pointer;
	line-height: 22px;
}
.mob-chkbx-group
	.custom-checkbox
	.custom-control-input:focus
	~ .custom-control-label::before {
	box-shadow: none !important;
	outline: none !important;
	border-color: #20639b !important;
}
.mob-chkbx-group
	.custom-control-input[disabled]
	~ .mob-chkbx-group
	.custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
	background-color: #c5c9cc;
	border: 1px solid #20639b;
	cursor: not-allowed;
}
/* .disablecursor .custom-checkbox.b-custom-control-sm .custom-control-label:after,
.input-group-sm .custom-checkbox .custom-control-label:after {
	cursor: not-allowed;
} */
.disablecursor custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	cursor: not-allowed;
}
.option-media-image {
	width: 140px;
	height: 140px;
	border: 1px solid rgba(140, 140, 140, 0.3);
	border-radius: 5px;
	overflow: hidden;
}
.br-5px {
	border-radius: 5px;
}

.view-image-icon {
	top: 51px;
	left: 33px;
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 14px;
	color: #ffffff;
	z-index: 2;
}

.mcq-image-modalclose {
	top: 10px;
	right: 10px;
	position: fixed;
	z-index: 11000;
}
#viewimagemodal___BV_modal_backdrop_ {
	background: rgba(52, 64, 84, 0.35);
	backdrop-filter: blur(15px);
	border-radius: 0px;
	opacity: unset;
}
#viewimagemodal .modal-body {
	padding: 0;
}
.border-image {
	border-radius: 10px;
}
.image-blur-overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(2px); /* blur effect */
	background: rgba(0, 0, 0, 0.5); /* dark overlay */
	z-index: 1;
}
</style>
